import {
  TGenericIngestionSettings,
  TIngestionDeleteType,
  TIngestionInsertType,
  TIngestionType,
} from './IngestSettings.interface';

const ingestTypeOverwrite: TIngestionType = 'overwrite';
const ingestTypeAppend: TIngestionType = 'append';
const ingestTypeUpdate: TIngestionType = 'update';

const ingestTypeOverwriteLabel = 'Overwrite';
const ingestTypeAppendLabel = 'Append';
const ingestTypeUpdateLabel = 'Update';

const insertTypeIncremental = {
  label: 'Incremental',
  value: 'incremental' as TIngestionInsertType,
};
const insertTypeTS = { label: 'Timestamp', value: 'timestamp' as TIngestionInsertType };

const InsertsComponentName = 'InsertsForm';
const UpdatesComponentName = 'UpdatesForm';
const DeletesComponentName = 'DeletesForm';

const defaultDeleteType = 'flag' as TIngestionDeleteType;

const columnTypeDateTime = 'DATETIME';
const columnTypeText = 'text';

const inputHeight = 40;
const inputWidth = 310;

const genericDefaultSettings: TGenericIngestionSettings = {
  idColumn: '',
  columnType: columnTypeText,
  timeFormat: '',
};

const defaultUpdateSettings = {
  useNew: true,
  useUpdate: false,
  useDelete: false,
  delete: {
    ...genericDefaultSettings,
    deleteType: defaultDeleteType,
    flagColumn: '',
    flagValue: '',
  },
  insert: {
    ...genericDefaultSettings,
    insertType: insertTypeIncremental.value,
  },
  update: {
    ...genericDefaultSettings,
  },
};

export {
  ingestTypeOverwrite,
  ingestTypeAppend,
  ingestTypeUpdate,
  ingestTypeOverwriteLabel,
  ingestTypeAppendLabel,
  ingestTypeUpdateLabel,
  insertTypeIncremental,
  insertTypeTS,
  InsertsComponentName,
  UpdatesComponentName,
  DeletesComponentName,
  defaultDeleteType,
  columnTypeDateTime,
  columnTypeText,
  inputHeight,
  inputWidth,
  defaultUpdateSettings,
};
